module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "default",
    attrs: {
      "id": "d8e1485NaN"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e123515"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_toc_r1#d6e3",
      "id": "d7e3"
    }
  }, [_vm._v("Chapter 2 ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e124015"
    }
  }, [_vm._v("I gripped the sink, trying to cut off the students’ voices echoing in my head. I stared at my reflection in the mirror in the girl’s light-blue locker room, where, like all teenagers, I was exposed to every kind of abuse and threat possible, both physically and psychologically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e126115"
    }
  }, [_vm._v("I passed my hand in front of the faucet sensor and let the cold, clear flow envelop my fingers. It was soothing as it rinsed away my anger. Ana had told the headmaster that I had cheated on the math test, which was a pure lie. Lyli had been kind enough to warn me, so I quickly left history class to catch my breath before confronting him. There was nothing I could do about it. He would fail me. Not only did Ana have brown hair, which gave her the advantage of fitting in and being accepted, but she had also won the principal’s support against me. She ruled the corridors. Skipping three grades when I was twelve had not helped me to be popular in any way. I had taken placement exams and had simply done better than average.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e129815"
    }
  }, [_vm._v("“Alexia?” Lyli called from outside the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e130315"
    }
  }, [_vm._v("I didn’t want to see anyone, but I couldn’t ignore her, especially since she was my only ally. Lyli and I had an odd friendship, one of trust and care, but not one of love and devotion. We were there for each other during the hard times, but we fit in with different crowds, so we  usually kept our distances and allowed her social circles to grow. She was toward the top of the school social ladder, while I faded at the bottom. But despite it all, she had always been there for me and looked out for me. She was the one person who never laughed at me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e133516"
    }
  }, [_vm._v("When I was eleven years old, I had asked her why her parents adopted me. She just looked at me with large, doe eyes. “What do you mean? Don’t you remember?” she had asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e134716"
    }
  }, [_vm._v("“No,” I had replied. “I don’t remember anything from before the age of ten. I only remember you waking me up one morning. It was as if my life started then,” I had answered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e135916"
    }
  }, [_vm._v("“Aw, I’m your first memory,” she had said with a smile. She had then told me that the government had asked her parents to take me in after my mother died. My father was unknown. Supposedly, I had been in some kind of accident and had lost my memory. I had asked if my parents had black hair and violet eyes, but no one ever had answers. I didn’t even know my parents’ names. It was as if they had never even existed. I wanted to know everything about my mother, but I was angry with my dad. What had happened to him? Did he leave my mother to die? Did he know that I’d survived? All these years, Lyli had been the one to listen to my distress, but her concern never seemed genuine. It was as if she was just there for me because I lived with her. That was it and nothing more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e140416"
    }
  }, [_vm._v("“Alexia?” Lyli repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e140916"
    }
  }, [_vm._v("“Yes,” I replied.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e141416"
    }
  }, [_vm._v("“Matthew is here, and he wants to talk to you.” Her voice was hesitant and distant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e142316"
    }
  }, [_vm._v("“Matthew?” I asked. I didn’t know of any Matthews in any of my classes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e143116"
    }
  }, [_vm._v("“Our leader.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e143716"
    }
  }, [_vm._v("I had never met Matthew before, but after what had happened  yesterday, I dreaded the thought of having to face him. I would never tell anyone, not even Lyli, that I despised the man. The glimmer in his eyes reflected his lies. Self-interest seemed to rule his hand, and no conscience lived behind his mirror eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e145917"
    }
  }, [_vm._v("Whenever he spoke of the ongoing war, it sounded as if his soldiers were nothing but discarded pawns. Age didn’t matter when it came to his men; he just wanted numbers and didn’t care if the hands carrying the guns were those of an adult or a child. He plucked his soldiers from their families without warning, and the majority never returned or were completely forgotten. When someone turned twenty-five, they would just vanish. Every couple of months, Matthew announced the soldiers who didn’t return, and he was grateful for their loyalty and sacrifice in serving the Community. But no one had ever asked those men and women whether they wanted to hold arms or not. They had just been taken because Matthew needed the extra manpower.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e149717"
    }
  }, [_vm._v("Those soldiers who did return acted as if nothing had ever happened and never shared any stories. We also never saw any images of the war and didn’t have memorials or military cemeteries. I really felt like I was the only one who noticed his hypocrisy. But I knew better . . . I couldn’t share my opinions, knowing that there would be dire consequences for treason or for challenging the law.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e151817"
    }
  }, [_vm._v("“Alexia?” Lyli asked again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e152317"
    }
  }, [_vm._v("My heart stopped and fell to my knees. My thoughts scrambled in my head and I could hardly think straight. I didn’t understand. Why did the leader of our Community want to see me?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e153517"
    }
  }, [_vm._v("“Alexia?” Matthew said in a soft tone. “First of all, happy birthday. You’re fifteen now, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e154317"
    }
  }, [_vm._v("I froze for a second to try to slow down my heart rate. Out of all the people in Tamizeh, why and how did he know it was my birthday? I never celebrated my birthday. Lyli was the only other person who  knew about my birthday, and that was because hers was only a week after mine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e156618"
    }
  }, [_vm._v("I knew I couldn’t stay in the bathroom forever, so I opened the door, slightly fearing what was about to happen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e157518"
    }
  }, [_vm._v("He stood before me, a middle-aged man with brown hair and blue eyes. Four men dressed in black suits stood behind him. Lyli was standing by his side, smiling. This was the Matthew, the one at the head of the government, the leader of Tamizeh. This man’s pictures hung everywhere in our school, his smiling face flashing in our hallways.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e159318"
    }
  }, [_vm._v("“What’s going on?” I asked. I tried not to look Matthew in the eye; he was a hypocritical, heartless, control freak who was obsessed with war. Lyli just stood there emotionless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e160418"
    }
  }, [_vm._v("“I have a few questions for you, Alexia. If you don’t mind, you will have to come with us. We have already talked to your teachers and Lyli’s parents, so they won’t worry about your absence.” He talked slowly, as if I were a toddler without a brain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e161918"
    }
  }, [_vm._v("“Yes, sir,” I said tentatively, knowing that I owed him a lot of respect. From our brief encounter, I already didn’t like him. He always seemed to be hiding something from us, his people. He had a grin that shouted insanity as his eyes glimmered with malicious intent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e163618"
    }
  }, [_vm._v("“Good. Lyli, you can go now, thank you. Alexia will be home in a few hours.” Matthew hurriedly pushed her away. Then he briskly walked down the hallway with his men shadowing him. I hurried to catch up, not knowing what else to do.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e165118"
    }
  }, [_vm._v("“Is this about yesterday afternoon?” I dared to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e165718"
    }
  }, [_vm._v("“A bit, but it’s bigger than that. But to be clear, I ask the questions. All right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e166718"
    }
  }, [_vm._v("I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e167318"
    }
  }, [_vm._v("“Hungry? We can grab a bite before getting down to business.” He had a shallow, almost superficial smile that contrasted his friendly tone. I just nodded, although I had just eaten lunch an hour ago. “The cafeteria’s this way, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e169519"
    }
  }, [_vm._v("I shook my head. “It’s on the west side of the campus.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e170019"
    }
  }, [_vm._v("“How far away?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e170519"
    }
  }, [_vm._v("“A five-and-a-half minute walk if we don’t cross the field.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e171119"
    }
  }, [_vm._v("“And if we do?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e171619"
    }
  }, [_vm._v("“Two.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e172119"
    }
  }, [_vm._v("“Then we cross.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e172719"
    }
  }, [_vm._v("He bolted off again with his strong, long gait, while I did my best to keep up beside him. There were guns lined up at the end of every hall in case of an attack, and although every student and teacher had been taught how to use them, they had never been used.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e174119"
    }
  }, [_vm._v("“They’re nice, right?” Matthew said, pointing at the guns.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e174719"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e175219"
    }
  }, [_vm._v("“Do you shoot?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e175819"
    }
  }, [_vm._v("“Never have. That is outside of the required school training.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e176319"
    }
  }, [_vm._v("“But you’ve kept up with your martial arts, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e176819"
    }
  }, [_vm._v("I nodded, uncomfortable from his knowledge. Hardly anyone knew I studied martial arts, although it was probably obvious after the fighting yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e178019"
    }
  }, [_vm._v("“Good, good.” He smiled again, and we were quiet for the remainder of the walk.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e178919"
    }
  }, [_vm._v("The sun burned my eyes, so I looked at the grass. Everyone stared at us as we made our way over to the west side of the campus, which made me extremely self-conscious.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e180019"
    }
  }, [_vm._v("When we entered the cafeteria, Matthew motioned for his men to remain outside. He walked to the head of the line and pushed in front of everyone. He grabbed my arm and pulled me beside him. He then took two trays and asked me what I wanted to eat. I told him I wasn’t hungry, but he insisted, so I accepted a small salad while he scarfed down what was equivalent to a three-course meal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e182219"
    }
  }, [_vm._v("Once he had emptied his plate, he pushed our trays aside and stared at me from across the table. I stayed perfectly still and quickly diverted my eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e183820"
    }
  }, [_vm._v("“You have beautiful, violet eyes, Alexia,” he said as he laced his plump fingers and planted both elbows on the table.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e184620"
    }
  }, [_vm._v("“Thank you,” I mumbled. I noticed the gold ring on his left hand with a large “M” pounded into it. He had been married, but his wife had passed away the year I was born. I didn’t know much about her, because we never focused on politics in history class, but I knew the ring wasn’t from her. The ring had been passed down from generation to generation until it had been placed on his finger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e186720"
    }
  }, [_vm._v("“What are you staring at?” he said sharply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e187320"
    }
  }, [_vm._v("“I’m sorry, sir. I was just noticing your ring.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e187820"
    }
  }, [_vm._v("“Oh this?” He pulled it off and handed it to me. As I held the ring between my thin fingers, I felt like I had seen it before. But that was impossible. I quickly handed it back to him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e189020"
    }
  }, [_vm._v("“Do you know what the ‘M’ stands for?” Matthew asked. “It stands for ‘Matthews.’ Do you know how long I’ve had it?” I shook my head, and he glared at me with disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e190220"
    }
  }, [_vm._v("“Almost ninety years,” he said. My eyes widened, and he laughed. I knew he was old and didn’t look his age, but I didn’t know how old he really was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e191520"
    }
  }, [_vm._v("“Yeah, I know, I look like I’m forty, not one hundred and thirty-three. I’ve had my telomere cells elongated on more than one occasion, but I’m still getting old. Still haven’t found the fountain of youth.” He chuckled lightly, then grew serious. “So you know I’ve had this since the beginning . . .” His statement resonated like a question and I wasn’t able to follow, so I tilted my head slightly to signal the need for an explanation. “Since the beginning of the end of the war. Since my father asked me to finish what he started. We’re getting closer to winning, you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e194820"
    }
  }, [_vm._v("I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e195420"
    }
  }, [_vm._v("“And you’re aware of the issues concerning the war and its  implications on our Community?” His tone shifted again to a lighter, more joyful one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e197021"
    }
  }, [_vm._v("“Not really . . .” I hesitated, uncomfortable admitting to ignorance. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e197521"
    }
  }, [_vm._v("“But you know that we need to keep fighting, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e198121"
    }
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e198621"
    }
  }, [_vm._v("His darting eyes violently glared at me. “Why?!” His voice caught the attention of everyone around us. I backed away in fear as my heart raced. “Because if we don’t, every other Community around will destroy us! Do you know how this all started? This world used to be great, and then everyone wasted all the resources, which drove everyone to fight for everything. This world was reigned by chaos, and because we were a strong Community, we survived. We claimed land and now we strive to keep it. If we don’t show the other communities out there that we are strong and infallible, we will perish just like all the other villages that have been annihilated. Now do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e202021"
    }
  }, [_vm._v("I nodded my head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e202621"
    }
  }, [_vm._v("“Good! Now let’s go.” He pushed out of his chair, stepped around the table, and latched onto my wrist. He yanked me out of my chair and led me out.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e203721"
    }
  }, [_vm._v("“Where are we going?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e204321"
    }
  }, [_vm._v("“The closest base.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e204821"
    }
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e205321"
    }
  }, [_vm._v("“Because this conversation isn’t over, and this place is too public to continue.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e206221"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e206721"
    }
  }, [_vm._v("“Just follow!” he yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e207321"
    }
  }, [_vm._v("Halfway down the hall, he let go of my arm. With every step, he seemed to relax until his gait was back to normal and I could keep up with his pace without fearing his aggression.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e208421"
    }
  }, [_vm._v("As we approached the main entrance, Matthew pulled out his ID  card and flashed it over a sensor, which unlocked a door and signed him out of the building. This was all for security reasons so the Community could keep track of our whereabouts. The voice from the small machine read his name aloud, “Matthew Matthews . . . goes by Matthew.” I stifled a laugh. No one ever called Matthew by his full name. I quickly swiped my card. The voice recognized me as well: “Alexia, goes by Alexia.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e211822"
    }
  }, [_vm._v("Matthew stopped. “It doesn’t recognize your last name? I know it’s not on the enrollment list, but not even on your identification card?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e212722"
    }
  }, [_vm._v("I shook my head. I had always been simply Alexia.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e213222"
    }
  }, [_vm._v("“Do you know your last name?” Matthew asked. I shook my head again and tried not to roll my eyes in annoyance. “You don’t have the slightest idea?” I shook my head a third time, irritated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e214422"
    }
  }, [_vm._v("“Shouldn’t you be able to tell me my last name? You have access to everyone’s records,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e215222"
    }
  }, [_vm._v("Matthew smirked. “I know you better than you know yourself. You were born March 25 at 10:34 in the evening fifteen years ago. You do not know your family. You’ve skipped three grades: fifth, sixth, and ninth. You like archery and have won numerous tournaments. You are almost never tired; therefore, you stay up late, trying to be productive, but it’s not insomnia. Physical challenges do not exist for you. Anything that needs to be drawn out for others you see clearly in your mind—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e218222"
    }
  }, [_vm._v("“How do you know all of this?” I was scared. I didn’t care if he was my leader or not—he was creepy and something wasn’t right. Sweat started to pearl on the back of my neck as my heart pounded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e219422"
    }
  }, [_vm._v("“Records.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e219922"
    }
  }, [_vm._v("“Then why do you need to question me? And on what?” I felt offended from a violation of privacy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e220822"
    }
  }, [_vm._v("“Our Community,” Matthew replied, frustration rising in his voice. “The rest of the conversation will have to wait until we’ve reached my office.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e222623"
    }
  }, [_vm._v("“Why?” I didn’t understand what was happening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e223123"
    }
  }, [_vm._v("“I’m in charge! I am the authority! I ask the questions!” Matthew yelled with piercing eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e224023"
    }
  }, [_vm._v("My heart exploded as his glare pounded me into the earth. He had lost his temper again. Maybe I did owe him more respect as our Community’s leader, but I had never seen him earn it. I swallowed the lump in my throat. I needed to hold my tongue. I didn’t want to get arrested for treason.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e225823"
    }
  }, [_vm._v("I kept quiet as he grabbed me by the arm and pulled me to his car. He opened the back door and threw me in. I felt abused, abducted, and imprisoned. A few minutes ago, I had been at school having a regular day, but then our Community’s leader had practically kidnapped me without an explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e227623"
    }
  }, [_vm._v("The car was long with a couple of doors. I expected a community leader to have a chauffeur, but Matthew sat behind the wheel. Everything was black—the metal, the leather seats, the gearshift, the windows, even the rearview mirror. I put on my seatbelt, wishing this were all a dream. Matthew reached into his pocket and pulled out a small, metallic band with a glowing, electric-blue circle emblem. It was the newest anti-gravity ring model. When I had first learned the science behind it, I thought it was the coolest thing. It didn’t actually repel gravity, which was impossible, but it strengthened surrounding forces of gravity so things could hover horizontally over the ground and also vertically. I looked at it intensely, recalling every aspect of its incredible features as Matthew put it on his finger. The car rose off the ground and floated. I looked out the window, but everything was black. I wanted to protest, but I was intimidated and confused. My head spun, and my mind couldn’t keep up with my thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e233124"
    }
  }, [_vm._v("Matthew stopped the car and turned in his seat to look at me. I diverted my gaze, trying to avoid his stare. I felt like an open book, and Matthew was flipping through the pages, completely unaware of my privacy. I wanted to jump out of the car, regardless of how high we were floating.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e234924"
    }
  }, [_vm._v("He leaned across the seats, grabbed my left wrist, and pulled me toward him. I tried to resist, but he was much stronger. I had never been overpowered before, and I suddenly felt vulnerable for the first time. Years of martial arts training had helped me realize that I was abnormally strong even though I was small.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e236724"
    }
  }, [_vm._v("Matthew tightened his grip, then reached into his pocket and took out a small needle. I pushed him away, pulling, twisting, and trying to pry open his grip. His eyes glared at me as he bit the cap off the needle, then quickly stabbed the needle into my left hand. Within seconds, I felt the clear liquid travel through my bloodstream, through my body, making me shiver. Matthew let go, and I jumped back, holding my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e239124"
    }
  }, [_vm._v("“As you fall asleep, try to keep up with what I have to say.” He looked at me as if I was a defenseless animal, but I felt like a wild monster ready to tear him apart.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e240324"
    }
  }, [_vm._v("“Why did you do that? What did you inject into my hand? Let me go! You can’t keep me here.” I tried to pull the door open, but it was locked. I tried to roll the window down, but it wouldn’t budge. I was panicking and felt the walls closing in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e241824"
    }
  }, [_vm._v("“You’re impossible to deal with! Just listen. You don’t have a choice.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e242324"
    }
  }, [_vm._v("“No! You just drugged me!” I was afraid, but I had to fight back one way or another. I started slamming my feet into the back of the seat. I ripped off my seatbelt, then I leaned across the width of the car, stretching and reaching for his door, but before I could get halfway to the handle, he grabbed my wrist and twisted. I immediately recoiled in pain. I held the injured limb in my lap as rage boiled inside me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e244424"
    }
  }, [_vm._v("“You need to stay calm,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e245525"
    }
  }, [_vm._v("I lunged for the wheel, not really thinking through my strategy, but frantically wishing to get away from him. He pushed my arm out of the way then slammed his elbow in the middle of my chest, and I had to cough to take in air. “One more stupid decision and there will be worse consequences,” he said in a patronizing tone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e247325"
    }
  }, [_vm._v("The car came to a startling halt, catapulting my body forward and slamming me into the back of the seat. I leaned back and caught my breath. Matthew lunged toward me and violently slapped me across my face. It stung and burned, but I tried not to react. My eyes watered lightly as I treaded in dangerous waters. He leaned back and observed, waiting for my response, but I couldn’t speak. His last reaction had been so direct and shocking that I had lost all confidence. The slap had been dehumanizing and struck me at the core.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e250025"
    }
  }, [_vm._v("“You do as I say, or I will make you do as I say. It’s simple,” he said emotionlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e250925"
    }
  }, [_vm._v("Blood rushed to my face. I sat still and pulled the belt across my waist. I didn’t know what else to do other than surrender, but I was not going to remain submissive forever.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e252025"
    }
  }, [_vm._v("“Good. I knew you were smart.” Matthew turned around again and started the car once more. I didn’t dare attack him when he had his back to me. I was a lamb in a lion’s den.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e253225"
    }
  }, [_vm._v("“What do you know about the S.S. Pill?” Matthew asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e253825"
    }
  }, [_vm._v("I was starting to feel the effects of the drug slowly disperse and spread inside of me. I knew that “S.S.” stood for “Superior Structure,” although most of the Community claimed it was “Super Strength.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e254925"
    }
  }, [_vm._v("I leaned my head against the seat. “When we turn fifteen, we take the pill to strengthen our bones and muscles, preparing us for war.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e255825"
    }
  }, [_vm._v("“You’re right. But you don’t have to take the S.S. Pill, because it’s already in your system,” Matthew said with a grin.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e256625"
    }
  }, [_vm._v("My head felt dizzy, my fingers tingling. What was he talking about? I had never taken the S.S. Pill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e257525"
    }
  }, [_vm._v("“You’re very special, Alexia. Your mother was given the S.S. Pill  when she was pregnant with you, which is why you don’t have to take it. It’s been flowing through your body all these years.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e259126"
    }
  }, [_vm._v("My stomach dropped to the floor. What did he know about my mother? I tried to lift my head, but it was too heavy. I thought back to all those times when I scraped my arm or skinned my knee, and how my body quickly healed itself. Everything suddenly made sense, but I grew frightened. Matthew knew more about me than I knew about myself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e261226"
    }
  }, [_vm._v("“How do you know my mother?” I slurred.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e261826"
    }
  }, [_vm._v("“I ask the questions,” he snarled. “What do you know about the War? The last time I asked you seemed to be . . . confused.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e262626"
    }
  }, [_vm._v("“Not much. Only what we’re told at school,” I replied confidently, trying to hide my fear. My ears started to pressurize as the drug penetrated every capillary. I could taste its soapy and bitter flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e263826"
    }
  }, [_vm._v("“And you don’t have any questions?” Matthew replied in a casual tone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e264726"
    }
  }, [_vm._v("“Who is fighting the War? We hear of the victories every day, but who are the soldiers? We don’t see any pictures of them or meet them. Why? Are they artificial intelligence?” I had asked my teachers these questions before, but they simply pushed them off to the side, clueless of the answers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e266726"
    }
  }, [_vm._v("“After graduating from high school, the class is separated into two. Half stay in the Community as civilians, while the other half becomes soldiers. Both the civilians and the soldiers lose contact with their families, because one should not depend on others or get attached, like grandparents who spoil their grandchildren. It’s a complicated strategy, but every other generation in a family joins the military forces, and as soon as the students graduate, they’re sent off to opposite sides of the Community to work. It keeps everyone focused on their jobs. It’s really efficient.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e270026"
    }
  }, [_vm._v("“And no questions are raised. If you eliminate the difference  between soldier and civilian life, no one realizes that they’re soldiers,” I muttered under my breath, not believing his motives. He had been lying to the Community for years, even decades, saying how all he ever did was defend and protect the Community, making Tamizeh stronger, but in reality he had been tearing her apart and using her resources to feed his power. He knew the truth. I felt his icy stare bounce off the rearview mirror as he caught my words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e273227"
    }
  }, [_vm._v("“To answer your question as to whether or not they are artificial intelligence . . . yes and no,” Matthew continued, ignoring the tension between us. “The soldiers are trained and conditioned, but they are still humans, hence the S.S. Pill. But that’s not the only pill they take. As you know, the S.S. Pill is usually taken at the age of fifteen, but there are exceptions.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e275327"
    }
  }, [_vm._v("As he spoke, his words blended together and my vision blurred. My eyes grew heavy and closed against my will. I couldn’t keep my head up or speak or move. I tried to fight it as I took in deep breaths and reached for the door. I was too dizzy to make out which direction I was facing, and I could only see splotches of color instead of silhouettes. Nothing was clear, not even my thoughts. My neck gave in and slammed against the back of the seat, sending a shocking pain down my spine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e277827"
    }
  }, [_vm._v("And within a few seconds, I fell unconscious.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6de94b49","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lodi_9781937084325_epub_c5_r1.vue
// module id = 72
// module chunks = 0